import { css } from 'linaria';
import { styled } from 'linaria/react';

export const ceilingsGallerySelectionGroup = css`
  && {
    margin-bottom: 32px;
  }
`;

export const ceilingsGalleryGrid = css`
  && {
    grid-auto-flow: dense;
    gap: 24px;
    margin-bottom: 0;

    @media (--only-tablet) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`;

export const GalleryImageWrapper = styled.div`
  position: relative;
  height: 380px;
  cursor: pointer;

  @media (--to-desktop) {
    height: 216px;
  }
`;

export const ceilingsGalleryImageWrapper = css`
  &:nth-of-type(10n - 6) {
    grid-column-start: 1;
  }

  &:nth-of-type(10n -5),
  &:nth-of-type(10n -2) {
    height: 784px;

    @media (--from-tablet) {
      grid-row-start: span 2;
    }

    @media (--only-tablet) {
      height: 456px;
    }

    @media (--only-mobile) {
      height: 376px;
    }
  }
`;

export const ceilingsGalleryImage = css`
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: var(--rounding-l);
  object-fit: cover;
`;

export const ceilingsGalleryShowMoreBtnWrapper = css`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
`;
